import React from "react";
import { motion } from "framer-motion";
import { Truck, Sparkles, Gift } from "lucide-react";
import { useApp } from "../AppContext";

const PromoBanner = () => {
    const { lang } = useApp();
    return (
        <section
            id="promo"
            data-testid="promo-banner"
            className="relative py-14 sm:py-16 overflow-hidden"
        >
            <div className="max-w-6xl mx-auto px-6 sm:px-8 lg:px-12">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-50px" }}
                    transition={{ duration: 0.7 }}
                    className="relative overflow-hidden rounded-[36px] shadow-2xl"
                    style={{
                        background:
                            "linear-gradient(135deg, #002D62 0%, #4A7C59 35%, #C85A17 70%, #CE1126 100%)",
                    }}
                >
                    {/* Decorative blobs */}
                    <div className="absolute -top-16 -right-16 w-72 h-72 rounded-full bg-white/10" />
                    <div className="absolute -bottom-10 -left-10 w-56 h-56 rounded-full bg-white/5" />
                    {/* Diagonal stripes */}
                    <div
                        aria-hidden
                        className="absolute inset-0 opacity-10"
                        style={{
                            background:
                                "repeating-linear-gradient(45deg, transparent 0px, transparent 20px, rgba(255,255,255,0.15) 20px, rgba(255,255,255,0.15) 40px)",
                        }}
                    />

                    <div className="relative grid md:grid-cols-12 gap-6 items-center p-8 sm:p-12 text-white">
                        {/* Icon side */}
                        <div className="md:col-span-3 flex md:justify-center">
                            <div className="relative">
                                <div className="w-28 h-28 sm:w-32 sm:h-32 rounded-full bg-white/15 backdrop-blur flex items-center justify-center">
                                    <Truck className="w-14 h-14 sm:w-16 sm:h-16" strokeWidth={1.6} />
                                </div>
                                <motion.div
                                    animate={{ rotate: [0, 12, -8, 0] }}
                                    transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
                                    className="absolute -top-3 -right-3 w-12 h-12 rounded-full bg-white text-terracotta-600 flex items-center justify-center shadow-lg"
                                >
                                    <Sparkles className="w-6 h-6" />
                                </motion.div>
                            </div>
                        </div>

                        {/* Text side */}
                        <div className="md:col-span-9">
                            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur text-[11px] font-bold uppercase tracking-[0.25em] mb-3">
                                <Gift className="w-3.5 h-3.5" />
                                {lang === "es" ? "Promoción de lanzamiento" : "Launch Promo"}
                            </div>
                            <h2 className="font-serif font-black text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight">
                                {lang === "es" ? (
                                    <>
                                        Tu <span className="italic">primer delivery</span>{" "}
                                        <span
                                            className="px-3 py-0.5 rounded-xl"
                                            style={{ background: "#CE1126" }}
                                        >
                                            ¡GRATIS!
                                        </span>
                                    </>
                                ) : (
                                    <>
                                        Your <span className="italic">first delivery</span>{" "}
                                        <span
                                            className="px-3 py-0.5 rounded-xl"
                                            style={{ background: "#CE1126" }}
                                        >
                                            FREE!
                                        </span>
                                    </>
                                )}
                            </h2>
                            <p className="mt-3 text-base sm:text-lg text-white/90 max-w-2xl">
                                {lang === "es"
                                    ? "Sin mínimo de compra. Sin trucos. Solo nuestra forma de darte la bienvenida a la familia dominicana 🇩🇴."
                                    : "No minimum. No tricks. Just our way of welcoming you to the Dominican family 🇩🇴."}
                            </p>
                            <a
                                href="#order"
                                data-testid="promo-cta-btn"
                                className="inline-flex items-center gap-2 mt-6 px-7 py-3.5 rounded-full bg-white text-earth-900 font-bold text-sm hover:bg-earth-50 transition-colors shadow-lg"
                            >
                                <Truck className="w-4 h-4" />
                                {lang === "es" ? "Pedir con delivery gratis" : "Order with free delivery"}
                            </a>
                        </div>
                    </div>
                </motion.div>
            </div>
        </section>
    );
};

export default PromoBanner;
